import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import useIntl from '../../../hooks/useIntl';
import messages from './messages';
import useBaseTableProps from '../../../hooks/useBaseTableProps';
import { Table } from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import { useReportHistoryTable } from './hooks';
import { useEffect } from 'react';

type Props = {
  open: boolean,
  closeModal: () => void,
  rentForecastId: string,
};

const ReportHistoryModal = ({ open, closeModal, rentForecastId }: Props) => {
  const intl = useIntl();
  const baseTableProps = useBaseTableProps();
  const { headers, tableName, rows, count, totalCount, refetch } =
    useReportHistoryTable(rentForecastId);

  // Trigger on modal open
  useEffect(() => {
    if (!open) {
      return;
    }

    refetch();
  }, [open, refetch]);

  return (
    <Modal
      open={open}
      onClose={closeModal}
      title={intl.formatMessage(messages.reportHistoryTitle)}
      ModalProps={{
        PaperProps: {
          sx: {
            width: {
              xs: 'calc(100% - 32px)',
              sm: 540,
            },
            maxHeight: 'calc(100vh - 100px)',
          },
        },
      }}
    >
      <Table
        {...baseTableProps}
        headers={headers}
        intl={intl}
        name={tableName}
        rows={rows}
        count={count}
        totalCount={totalCount}
        showSettings={false}
      />
    </Modal>
  );
};

export default ReportHistoryModal;
